<template>
  <div class="dashboard">
    <!-- Background elements -->
    <img id="bg1" src="../assets/bg1.svg"/>
    <img id="bg2" src="../assets/bg2.svg"/>
    <img id="bg3" src="../assets/bg3.svg"/>
    <img id="bg4" src="../assets/bg4.svg"/>

    <v-content>
        <v-container fluid>
          <CoolLightBox
            :items="items"
            :index="index"
            loop
            @close="index = null">
          </CoolLightBox>
          <div class="main-container">
            <div class="home-content-absolute">
              <h1 class="main-headline">We can handle <span class="selection-pink">the truth</span></h1>
              <p class="main-sub">With Hard2say send anonymous messages to friends, work colleagues, relatives with some things that are difficult to say live.</p>
              <div class="btn-flex">
                <router-link class="start-btn" :to="{ name: 'send', params: { step: 1 }}">Start message</router-link>
                <a @click="setIndex(0)" class="video-btn"><img src="../assets/play.png"/>Watch the video</a>
              </div>
            </div>
          <!-- <video controls id="yt-player" src="../assets/video.mp4"></video> -->

        </div>
      </v-container>
    </v-content>

  </div>
</template>

<script>
import IssuesData from '../data.js';
import autocomplete from './autocomplete.vue';
import firebase from 'firebase'
import CoolLightBox from 'vue-cool-lightbox'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'

export default {
  name: 'Dashboard',
  props: {

  },
  components: {
    autocomplete,
    CoolLightBox
  },
  data () {
    return {
      items: [
            {
              src: 'https://youtu.be/2gK_U3Tu-wA',
              description: 'What is Hard2Say?',
            }
      ],
      index: null
    }
  },
  computed: {


  },
  methods: {
    setIndex(index) {
      this.index = index
    }
  },
  mounted() {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#video {
  display: none;
}
#bg1 {
    position: absolute;
    top: 0;
    left: 0;
    animation: float-y-1 10s infinite;
}
#bg2 {
    position: absolute;
    bottom: 0;
    left: 0;
    animation-delay: 0.25s;
    animation: float-x-1 8s infinite;
}
#bg3 {
    display: none;
    position: absolute;
    bottom: 0;
    left: 30%;
    animation-delay: 0.6s;
    animation: float-x-2 9s infinite;
}
#bg4 {
    position: absolute;
    bottom: 0;
    right: 0;
    animation-delay: 0.4s;
    animation: float-x-2 7s infinite;
}
@media (max-height: 700px) {
  #bg1, #bg3, #bg4 {
    height: 120px;
  }
  #bg2 {
    height: 200px;
  }
}
@media (max-width: 544px) {
  #bg1 {
    height: 100px;
  }
  #bg2, #bg3 {
    display: none;
  }
  #bg4 {
    height: 300px;
    animation: float-y-2 7s infinite;
  }
}
@media (min-width: 544px) {
  #bg1 {
    height: 150px;
  }
  #bg2, #bg3 {
    display: none;
  }
  #bg4 {
    height: 300px;
    animation: float-y-2 7s infinite;
  }
}
@media (min-width: 768px) {
  #bg2 {
    display: block;
  }
}
@media (min-width: 1100px) {
  #bg3 {
    display: block;
  }
}
.main-container {
  height: 100%;
  position: relative;
}
.dashboard {

}
.home-content-absolute {
  position: absolute;
  top: 50%;
}
h1.main-headline {
  font-weight: bold;
  text-align: left;
  font-family: Kanit;
  font-style: normal;
  font-weight: 300;
  line-height: 100%;
  color: #222;
  margin-top: 100px;
}
p.main-sub {
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 160%;
  text-align: left;
  color: #222;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
p {
  color: #000;
}
label {
  color: #fff !important;
}
.main-container {
  max-width: 1600px;
  margin: 0 auto;
}
p#message {
  padding: 15px;
  background-color: rgba(0,0,0,0.1) !important;
}
.btn-flex {
  display: flex;
  margin-top: 40px;
}
.start-btn {
  font-family: Kanit;
  font-style: normal;
  font-weight: normal;
  line-height: 100%;
  padding-bottom: 10px;
  border-bottom: 4px solid #F65996;
  border-radius: 2px 2px 2px 2px;
  transition: 0.2s all;
  color: #222;
}
.start-btn:hover {
  padding-bottom: 5px;
  text-decoration: none;
}
.video-btn {
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 160%;
  color: #222;
  margin-left: 40px;
  margin-top: 7px;
}
.video-btn img {
  margin-right: 8px;
}
#issue-form {
  max-width: 500px;
  margin: 0 auto;
  margin-top: -7px;
  margin-bottom: 100px;
  padding: 40px;
  display: none;
}
#note-issue {
  text-align: left;
  margin-top: -21px;
  font-size: smaller;
  color: rgba(0,0,0,0.5);
}
svg#svg-arrow {
  position: absolute;
  left: -134%;
  height: 120px;
  top: 700px;
}
p#arrow-text {
  color: #fff;
  font-weight: 600;
  position: absolute;
  left: -68%;
  width: 200px;
  font-size: 2em;
  top: 715px;
  line-height: 1.1em;
}

p.not-listed-btn {
  margin-bottom: 0px;
  margin-top: -10px;
  text-align: left !important;
  display: block;
}

p.not-listed-btn:hover {
  text-decoration: underline;
  cursor: pointer;
}

.v-autocomplete {
  position: relative;
}
.v-autocomplete .v-autocomplete-list {
  position: absolute;
}
.v-autocomplete .v-autocomplete-list .v-autocomplete-list-item {
  cursor: pointer;
}

#yt-player {
  max-width: 500px !important;
}

@media (max-width: 544px) {
  h1.main-headline {
    font-size: 48px;
    margin-top: 50px;
    margin-bottom: 15px;
  }
  p.main-sub {
    max-width: 90%;
  }
  .start-btn {
    font-size: 20px;
  }
  .video-btn {
    margin-top: 2px;
  }
  svg#svg-arrow {
    display: none;
  }
  p#arrow-text {
    display: none;
  }
  #yt-player {
    width: 100%;
    height: auto;
    min-height: 190px;
  }
}
@media (min-width: 544px) {
  h1.main-headline {
    font-size: 60px;
  }
  p.main-sub {
    max-width: 85%;
  }
  .start-btn {
    font-size: 22px;
  }
  .video-btn {
    margin-top: 2px;
  }
}
@media (min-width: 768px) {
  h1.main-headline {
    font-size: 72px;
  }
  p.main-sub {
    max-width: 75%;
  }
  .start-btn {
    font-size: 24px;
  }
  .video-btn {
    margin-top: 4px;
  }
}
@media (min-width: 1024px) {
  h1.main-headline {
    font-size: 80px;
  }
  p.main-sub {
    max-width: 70%;
  }
  .start-btn {
    font-size: 26px;
  }
  .video-btn {
    margin-top: 5px;
  }
}
@media (min-width: 1200px) {
  h1.main-headline {
    font-size: 92px;
  }
  p.main-sub {
    max-width: 65%;
  }
  .start-btn {
    font-size: 28px;
  }
  .video-btn {
    margin-top: 6px;
  }
}
@media (min-width: 1440px) {
  h1.main-headline {
    font-size: 100px;
  }
  p.main-sub {
    max-width: 60%;
  }
  .start-btn {
    font-size: 32px;
  }
  .video-btn {
    margin-top: 7px;
  }
}
@media (max-height: 700px) {
  h1.main-headline {
    margin-top: 50px
  }
}
@media (min-height: 1000px) {
  h1.main-headline {
    margin-top: 250px;
  }
}


</style>
